import type { Client } from '@zg-rentals/http-client';
import type { QueryOptions } from '@zg-rentals/react-query5';
import { YourRentalWebApiHandler_getYourRentalPageData } from '@zg-rentals/ts-your-rental-api-client';

export const getRentals = (httpClient: Client) =>
  ({
    queryKey: ['rentals'],
    queryFn: () => YourRentalWebApiHandler_getYourRentalPageData(httpClient),
    retry: false,
  }) satisfies QueryOptions;
